import React, { Component } from 'react';
import { Form, Input, Icon /* , Row, Col, Button */} from 'antd';

const FormItem = Form.Item;

const ConfirmForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },

  mapPropsToFields(props) {
    return {
      password: Form.createFormField({
        ...props.password,
        value: props.password.value,
      }),
    };
  },
  
  // onValuesChange(_, values) {
  //   console.log(values);
  // },
})(class extends Component {
  state = {
    passwordVisible: false,
  };

  passwordVisibilityChange = () => {
    this.setState({ passwordVisible: !this.state.passwordVisible });
  }
  
  render() {
    const { getFieldDecorator } = this.props.form;
    const { passwordVisible } = this.state;
    const passwordSuffix = <Icon type={passwordVisible ? 'eye-o' : 'eye'} onClick={this.passwordVisibilityChange} />;
    
    return (
      <Form>
        <FormItem
          {...this.props.formItemLayout}
          label="Mật khẩu"
        >
          {getFieldDecorator('password')(
            <Input
              placeholder="Nhập mật khẩu cũ"        
              type={passwordVisible ? 'text' : 'password'}
              suffix={passwordSuffix}
            />
          )}
        </FormItem>
        {/* <FormItem
          {...this.props.formItemLayout}
          label="Xác thực"
          extra="Chúng tôi phải đảm bảo rằng bạn không phải robot."
        >
          <Row gutter={8}>
            <Col span={16}>
              {getFieldDecorator('captcha')(
                <Input />
              )}
            </Col>
            <Col span={8}>
              <Button style={{ width: '100%' }}>Captcha</Button>
            </Col>
          </Row>
        </FormItem> */}
      </Form>
    );
  }
});

export default ConfirmForm;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Modals/ConfirmModal/ConfirmForm.js